import React, { useEffect, useState, useRef } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import Iframe from 'react-iframe';

// @mui material components
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Alert from '@mui/material/Alert';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import InputAdornment from '@mui/material/InputAdornment';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Snackbar from '@mui/material/Snackbar';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import TableHeader from 'components/Table/TableHeader';
import MDSelect from 'components/MDSelect';
import MDTypography from 'components/MDTypography';
import MDBadge from 'components/MDBadge';
import MDDatePicker from 'components/MDDatePicker';
import MDDateRange from 'components/MDDateRange';
import TabPanel from 'components/TabPanel/TabPanel';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Navbar from 'examples/Navbars/NavBar';
import Footer from 'examples/Footer';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';

import { getCostPOSummary } from 'services/Criteria';
import stepperName from './PurchaseOrderStatus';
import PurchaseOrderList from './PurchaseOrderList';
import PurchaseOrderStepper from './PurchaseOrderStepper';
import SearchSupplier from './SearchSupplier';
import SearchSupplierAdd from './SearchSupplierAdd';
import PurchaseOrderReceive from './PurchaseOrderReceive';
import SearchGroup from './SearchGroup';

const initAttr = {
  id: '',
  code: '',
  remark: '',
  order_no: '',
  type_id: '',
  supplier_id: '',
  vat_id: '2',
  status: 'edit',
  branch_receive: '',
  credit_day: '',
  credit_money: '',
  print_url: '',
  print_no: '0',
  detail_no: '0',
  created_at: '',
  updated_at: '',
  print: '',
  quotation: '',
  is_group: 'N',
  group_id: '',
  group_code: '',
  discount_unit: 'Y',
  date_record: Func.dateNow(),
  date_due: Func.dateNow(),
  is_require_step2: '0',
};

const initSupplier = {
  id: '',
  code: '',
  name: '',
  taxid: '',
  credit_day: '',
  credit_money: '',
  tel: '',
  company_name: '',
  email: '',
  business: '',
  vat_id: '2',
  address: '',
  province_id: '',
  district_id: '',
  subdistrict_id: '',
  zipcode: '',
  branch: '',
  remark: '',
  discount: '',
  enable: 'Y',
  created_at: '',
  updated_at: '',
  province_name: '',
  district_name: '',
  subdistrict_name: '',
  vat_name: '',
};

const initFind = {
  search: '',
  order_by: 'tb.code',
  order_sort: 'desc',
  page: 1,
  perPage: 10,
  pageTotal: 0,
  status: 'ACTIVE',
  user: 'ALL',
  period: 'ALL',
  date_start: Func.dateTimeFirstMonth(),
  date_stop: Func.dateTimeEndMonth(),
};

const initNavigate = {
  first: '',
  prev: '',
  next: '',
  last: '',
};

const cboStatus = [
  { id: 'ALL', name: 'ทั้งหมด' },
  { id: 'ACTIVE', name: 'ใช้งาน' },
  { id: 'edit', name: stepperName.edit.name },
  { id: 'waiting', name: stepperName.waiting.name },
  { id: 'request', name: stepperName.request.name },
  { id: 'approve', name: stepperName.approve.name },
  { id: 'approve_2', name: stepperName.approve.name },
  { id: 'reject', name: stepperName.reject.name },
  { id: 'purchase', name: stepperName.purchase.name },
  { id: 'receive', name: stepperName.receive.name },
  { id: 'success', name: stepperName.success.name },
  { id: 'cancel', name: stepperName.cancel.name },
];

function PurchaseOrder() {
  const mod = 'purchase_order';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [navigate, setNavigate] = useState(initNavigate);
  const [notify, setNotify] = useState(null);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [stepper, setStepper] = useState({});
  const [cboVat, setCboVat] = useState([]);
  const [cboType, setCboType] = useState([]);
  const [cboBranch, setCboBranch] = useState([]);
  const [cboUser, setCboUser] = useState([]);
  const [tab, setTab] = useState(0);
  const [image, setImage] = useState([]);
  const [photo, setPhoto] = useState({});
  const [modalPhoto, setModalPhoto] = useState(false);
  const [modalPrint, setModalPrint] = useState(false);
  const [modalQuotation, setModalQuotation] = useState(false);
  const [limitApprove, setLimitApprove] = useState('N');
  const [vatId, setVatId] = useState('0');
  const [supplier, setSupplier] = useState(initSupplier);
  const listRef = useRef();
  const receiveRef = useRef();

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: 'tb.status', label: 'สถานะ', align: 'center' },
    { id: 'tb.code', label: t(`attr.code`), align: 'center' },
    { id: 'tb.supplier_id', label: 'ผู้จัดจำหน่าย', align: 'left' },
    { id: 'tb.branch_receive', label: 'รับเข้า', align: 'left' },
    { id: 'tb.order_no', label: 'เลขที่สั่ง', align: 'left' },
    { id: 'tb.remark', label: 'หมายเหตุ', align: 'left' },
    { id: 'count', label: 'รายการ', align: 'left', sort: false },
    { id: 'tb.user_id', label: 'ผู้ทำรายการ', align: 'left' },
    { id: 'tb.nettotal', label: 'ราคาซื้อ', align: 'right' },
    { id: 'tb.deposit', label: 'มัดจำ', align: 'right' },
    { id: 'tb.date_record', label: 'วันสั่งซื้อ', align: 'center' },
    { id: 'tb.date_due', label: 'กำหนดรับ', align: 'center' },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <Snackbar
        open
        autoHideDuration={3000}
        onClose={() => setNotify(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={() => setNotify(null)} severity={color} variant='filled'>
          {msg}
        </Alert>
      </Snackbar>
    );
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    setRecord([]);
    closeShow();

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      status: data.status,
      user: data.user,
      period: data.period,
      date_start: data.date_start,
      date_stop: data.date_stop,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const open = () => {
    setLoading(true);
    setAttr(initAttr);
    setTab(0);

    FetchData('GET', `/${mod}/${id}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(result.data);
        setSupplier(result.supplier);
        setNavigate(result.navigate);
        setStepper(result.stepper);
        setImage(result.image);
        setVatId(result.data.vat_id);

        setLoading(false);
      }
    });
  };

  const setDateRange = (start, stop) => {
    view({
      ...find,
      date_start: Func.dateTimeFormat(start.toDate()),
      date_stop: Func.dateTimeFormat(stop.toDate()),
      page: 1,
    });
  };

  const add = (item) => {
    setLoading(true);

    FetchData('PUT', `/${mod}`, app.token, {
      supplier_id: item.supplier_id,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        window.location.replace(`${mod}/${result.id}`);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const print = () => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/print`, app.token, {
      id: attr.id,
      lang: app.lang,
    }).then((result) => {
      setLoading(false);
      if (result.status === 'ok') {
        setAttr({ ...attr, print: result.data.print, print_no: result.data.print_no });
        setModalPrint(true);
      }
    });
  };

  const printGroup = () => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/printgroup`, app.token, {
      id: attr.id,
      lang: app.lang,
    }).then((result) => {
      setLoading(false);
      if (result.status === 'ok') {
        setAttr({ ...attr, print: result.data.print, group_no: result.data.group_no });
        setModalPrint(true);
      }
    });
  };

  const detail = () => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/detail`, app.token, {
      id: attr.id,
      lang: app.lang,
    }).then((result) => {
      setLoading(false);
      if (result.status === 'ok') {
        setAttr({ ...attr, print: result.data.print, detail_no: result.data.detail_no });
        setModalPrint(true);
      }
    });
  };

  const quotation = () => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/quotation`, app.token, {
      id: attr.id,
      lang: app.lang,
    }).then((result) => {
      setLoading(false);
      if (result.status === 'ok') {
        setAttr({ ...attr, quotation: result.data.print, quotation_no: result.data.quotation_no });
        setModalQuotation(true);
      }
    });
  };

  const copy = () => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('OPTIONS', `/${mod}/copy`, app.token, {
          id: id,
        }).then((result) => {
          if (result.status === 'ok') {
            window.location.replace(`/${mod}/${result.id}`);
            showNotify(t(`alert.addcomplete`), 'success');
          } else {
            setLoading(false);
            showNotify(t(`alert.saveerror`), 'error');
          }
        });
      }
    });
  };

  const editConfirm = () => {
    if (!Func.verifyLength(attr.type_id, 1)) return false;

    return true;
  };

  const edit = () => {
    if (!editConfirm()) return;

    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
          remark: attr.remark,
          order_no: attr.order_no,
          type_id: attr.type_id,
          date_record: attr.date_record,
          date_due: attr.date_due,
          vat_id: attr.vat_id,
          branch_receive: attr.branch_receive,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            showNotify(t(`alert.editcomplete`), 'success');
            if (vatId !== attr.vat_id) {
              window.location.reload();
            }
          } else {
            showNotify(t(`alert.${result.msg}`), 'error');
          }
        });
      }
    });
  };

  const editSupplier = (item) => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
          supplier_id: item.supplier_id,
        }).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            open();
            listRef.current.view();
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            showNotify(t(`alert.${result.msg}`), 'error');
          }
        });
      }
    });
  };

  const approve = async (status) => {
    if (
      ['edit', 'waiting', 'request'].includes(attr?.status) &&
      !['reject', 'cancel'].includes(status)
    ) {
      const criteria = await getCostPOSummary(app.token);
      let code;

      switch (supplier.credit_type) {
        case 'CREDIT':
          code = 'PO_CREDIT';
          break;
        case 'CASH':
          code = 'PO_CASHFLOW';
          break;
        default:
          code = 'PO_UNKNOWN';
      }
      const poData = criteria.find((item) => item.code === code);

      if (poData?.balance !== undefined) {
        if (parseFloat(attr?.nettotal) > parseFloat(poData?.balance)) {
          showNotify(`${poData.name}คงเหลือไม่เพียงพอ`, 'error');
          return;
        }
      }
    }

    Swal.fire({
      title: `คุณต้องการเปลี่ยนสถานะเป็น \n"${stepperName[status].name}" ใช่หรือไม่ ?`,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
        placeholder: 'กรุณาป้อนหมายเหตุเมื่อกดยกเลิก',
      },
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        const remark = Swal.getInput()?.value || '';
        if (status === 'cancel' && remark === '') {
          showNotify('กรุณากรอกหมายเหตุ', 'error');
          return;
        }
        if (status === 'success' && remark === '') {
          showNotify('กรุณากรอกหมายเหตุ', 'error');
          return;
        }

        setLoading(true);
        FetchData('OPTIONS', `/${mod}/approve`, app.token, {
          id: id,
          status: status,
          remark: remark,
        }).then((result) => {
          if (result.status === 'ok') {
            open();
            listRef.current.view();
            showNotify(t(`alert.editcomplete`), 'success');
          } else {
            setLoading(false);
            showNotify(result.msg, 'error');
          }
        });
      }
    });
  };

  const openPhoto = (item) => {
    setPhoto(item);
    setModalPhoto(true);
  };

  const creditDisplay = (inp) => {
    if (inp === 'CASH') return 'เงินสด';

    return 'เครดิต';
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(initAttr);
        setCboType(result.type);
        setCboVat(result.vat);
        setCboBranch(result.branch);
        setCboUser(result.user);

        if (id === undefined) {
          view(find);
        } else {
          open();
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const copyLink = () => {
    navigator.clipboard.writeText(attr.po_quotation);
    showNotify(t(`alert.copycomplete`), 'success');
  };

  const openLink = () => {
    window.open(attr.po_quotation, '_blank');
  };

  const btnOpen = (item) => {
    return (
      <NavLink to={`/${mod}/${item.id}`}>
        <MDButton
          variant='text'
          color='info'
          size='small'
          sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}
        >
          {item.code}
        </MDButton>
      </NavLink>
    );
  };

  const renderSearch = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <MDBox
              noValidate
              component='form'
              role='form'
              onSubmit={(e) => {
                e.preventDefault();
                view({ ...find, period: 'ALL', page: 1 });
              }}
            >
              <MDInput
                name='searchform'
                fullWidth
                value={find.search}
                type='search'
                onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                  ),
                  autoComplete: 'off',
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDInput
              fullWidth
              value={find.status}
              defaultValue='ALL'
              select
              onChange={(e) => view({ ...find, status: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <span>สถานะ :</span>
                  </InputAdornment>
                ),
              }}
            >
              {cboStatus.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <MDInput
              fullWidth
              value={find.user}
              defaultValue='ALL'
              select
              onChange={(e) => view({ ...find, user: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <span>ผู้รับผิดชอบ :</span>
                  </InputAdornment>
                ),
              }}
            >
              <MenuItem value='ALL'>ทั้งหมด</MenuItem>
              {cboUser.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </MDInput>
          </Grid>

          {find.period === 'ALL' ? (
            <Grid item xs={12} sm={12} md={6} lg={2}>
              <MDButton
                variant='outlined'
                color='secondary'
                fullWidth
                sx={{ p: 1.5 }}
                onClick={() => view({ ...find, period: 'DATE', page: 1 })}
              >
                <Icon>edit_calendar</Icon>&nbsp;เลือกช่วงเวลา
              </MDButton>
            </Grid>
          ) : null}
          {find.period === 'ALL' ? null : (
            <Grid item xs={12} sm={12} md={12} lg={7}>
              <MDDateRange
                dateStart={find.date_start}
                dateStop={find.date_stop}
                callBack={setDateRange}
                closeDate={() => view({ ...find, period: 'ALL', page: 1 })}
              />
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  const renderList = () => {
    const diffDisplay = (row) => {
      if (row.diff_due * 1 > 0) {
        return (
          <MDBox className='nowrap'>
            <code>{row.diff_due} วัน</code>
          </MDBox>
        );
      }

      if (row.diff_due * 1 === 0) {
        return (
          <MDBox className='nowrap'>
            <code className='color-success'>ถึงกำหนด</code>
          </MDBox>
        );
      }

      return null;
    };

    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9} md={10} lg={11}>
            {renderSearch()}
          </Grid>
          <Grid item xs={12} sm={3} md={2} lg={1}>
            <SearchSupplierAdd callback={add} />
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ minHeight: 400 }}>
              <Table aria-label='datatable table'>
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id} hover>
                      <TableCell align='center' width={160}>
                        {Func.statusDisplay(row)}
                      </TableCell>
                      <TableCell align='center'>
                        <MDBox>{btnOpen(row)}</MDBox>
                        {row.is_group === 'Y' ? (
                          <MDBox>
                            <code>{row.group_code}</code>
                          </MDBox>
                        ) : null}
                      </TableCell>
                      <TableCell>
                        <MDBox>{row.supplier_code}</MDBox>
                        <MDBox className='cut' width={150}>
                          {row.supplier_name}
                        </MDBox>
                      </TableCell>
                      <TableCell align='left' className='nowrap'>
                        {row.branch_code}
                      </TableCell>
                      <TableCell align='left'>{row.order_no}</TableCell>
                      <TableCell>
                        <MDBox className='cut' width={300}>
                          {row.remark}
                        </MDBox>
                        <MDBox className='nowrap color-danger'>
                          {row.remark_approve === '' ? null : (
                            <span>{row.remark_approve}&nbsp;</span>
                          )}
                          {row.copy_code === '' ? null : (
                            <span className='nowrap color-default'>อ้างอิง : {row.copy_code}</span>
                          )}
                        </MDBox>
                      </TableCell>
                      <TableCell align='center'>
                        <code className='color-primary'>{row.count}</code>
                      </TableCell>
                      <TableCell align='left'>{row.user_name}</TableCell>
                      <TableCell align='right'>{Func.numberDisplay(row.nettotal, 2)}</TableCell>
                      <TableCell align='right'>
                        {row.deposit * 1 > 0 ? Func.numberDisplay(row.deposit, 2) : '-'}
                      </TableCell>
                      <TableCell align='center'>{Func.dateDisplay(row.date_record)}</TableCell>
                      <TableCell align='center'>
                        <MDBox>{Func.dateDisplay(row.date_due)}</MDBox>
                        {diffDisplay(row)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
                <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                  {t(`element.show_record`, { num: find.perPage })}&nbsp;
                  <Icon>keyboard_arrow_down</Icon>
                </MDButton>
                {renderShow}
                <Pagination
                  count={pageTotal}
                  variant='outlined'
                  color='secondary'
                  showFirstButton
                  showLastButton
                  page={pageNo}
                  onChange={(e, p) => view({ ...find, page: p })}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderStepper = () => {
    const action = (key) => {
      switch (attr.status) {
        case 'edit':
          if (limitApprove === 'Y')
            return key === 'waiting' || key === 'purchase' || key === 'cancel';
          return key === 'waiting' || key === 'request' || key === 'cancel';
        case 'waiting':
          if (limitApprove === 'Y') return key === 'purchase' || key === 'cancel';
          return key === 'request' || key === 'cancel';
        case 'request':
          return (
            (key === 'approve' && app.perm.approve_po) ||
            (key === 'reject' && app.perm.approve_po) ||
            key === 'cancel'
          );
        case 'approve':
          return (
            (key === 'purchase' && app.perm.approve_po && attr.is_require_step2 !== '1') ||
            (key === 'approve_2' && app.perm.approve_po_step2 && attr.is_require_step2 === '1') ||
            (key === 'cancel' && app.perm.cancel_po)
          );
        case 'approve_2':
          return (
            (key === 'purchase' && app.perm.approve_po_step2) ||
            (key === 'cancel' && app.perm.cancel_po)
          );
        case 'purchase':
          return key === 'cancel' && app.perm.cancel_po;
        default:
          return false;
      }
    };

    const stepLevel = (key) => {
      return (
        <Step sx={{ minWidth: 150 }}>
          <StepLabel StepIconComponent={PurchaseOrderStepper}>
            {action(key) ? (
              <MDButton
                variant='gradient'
                color={stepperName[key].color}
                size='small'
                onClick={() => approve(key)}
              >
                <Icon>{stepperName[key].icon}</Icon> &nbsp; {stepperName[key].name}
              </MDButton>
            ) : stepper[key] === undefined ? (
              <MDTypography variant='subtitle2'>{stepperName[key].name}</MDTypography>
            ) : attr.status === key ? (
              <MDBox>
                <MDBadge
                  badgeContent={stepperName[key].name}
                  variant='contained'
                  color={stepperName[key].color}
                  size='md'
                  container
                />
                <MDTypography variant='subtitle2'>{stepper[key].emp_name}</MDTypography>
                <MDTypography variant='subtitle2'>
                  {Func.dateTimeDisplay(stepper[key].created_at)}
                </MDTypography>
              </MDBox>
            ) : (
              <MDBox>
                <MDTypography variant='h6'>{stepperName[key].name}</MDTypography>
                <MDTypography variant='subtitle2'>{stepper[key].emp_name}</MDTypography>
                <MDTypography variant='subtitle2'>
                  {Func.dateTimeDisplay(stepper[key].created_at)}
                </MDTypography>
              </MDBox>
            )}
          </StepLabel>
        </Step>
      );
    };

    const stepInt = () => {
      if (attr.status === 'waiting') return 2;
      if (attr.status === 'request') return 3;
      if (attr.status === 'approve') return 4;
      if (attr.status === 'approve_2') return 5;
      if (attr.status === 'reject') return 6;
      if (attr.status === 'purchase') return 7;
      if (attr.status === 'receive') return 8;
      if (attr.status === 'success') return 9;
      if (attr.status === 'cancel') return 10;

      return 0;
    };

    return loading ? null : (
      <MDBox className='stepper' mt={3} mb={1}>
        <Stepper activeStep={stepInt()} alternativeLabel>
          {stepLevel('edit')}
          {stepLevel('waiting')}
          {stepLevel('request')}
          {stepLevel('approve')}
          {stepLevel('approve_2')}
          {stepLevel('reject')}
          {stepLevel('purchase')}
          {stepLevel('receive')}
          {stepLevel('success')}
          {stepLevel('cancel')}
        </Stepper>
      </MDBox>
    );
  };

  const renderInfo = () => {
    const readOnly = attr.status !== 'edit' && attr.status !== 'waiting';

    return (
      <MDBox className='card' p={2}>
        <Grid container>
          <Grid item xs={6}>
            <MDTypography variant='h5' mb={3}>
              ใบสั่งซื้อ
            </MDTypography>
          </Grid>
          <Grid item xs={6}>
            {attr.status === 'success' || attr.status === 'cancel' ? null : (
              <MDBox display='flex' justifyContent='end' gap={1}>
                <MDButton variant='gradient' color='success' size='small' onClick={edit}>
                  <Icon>save</Icon>&nbsp;{t(`element.save`)}
                </MDButton>
              </MDBox>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDSelect
              label='ประเภทสั่งซื้อ'
              labelDefault={t(`element.please_select`)}
              data={cboType}
              value={attr.type_id}
              onChange={(e) => setAttr({ ...attr, type_id: e.target.value })}
              inputProps={{
                autoComplete: 'off',
                readOnly: readOnly,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDSelect
              label='ภาษีมูลค่าเพิ่ม *'
              labelDefault={t(`element.please_select`)}
              data={cboVat}
              value={attr.vat_id}
              onChange={(e) => setAttr({ ...attr, vat_id: e.target.value })}
              inputProps={{
                autoComplete: 'off',
                readOnly: readOnly,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDDatePicker
              onChange={([date]) => {
                setAttr({ ...attr, date_record: Func.dateFormat(date) });
              }}
              value={new Date(attr.date_record)}
              input={{
                label: 'วันที่สั่งซื้อ',
                variant: 'standard',
                fullWidth: true,
              }}
              readOnly={readOnly}
            />
          </Grid>
          <Grid item xs={12}>
            <MDDatePicker
              onChange={([date]) => {
                setAttr({ ...attr, date_due: Func.dateFormat(date) });
              }}
              value={new Date(attr.date_due)}
              input={{
                label: 'กำหนดรับสินค้า',
                variant: 'standard',
                fullWidth: true,
              }}
              readOnly={attr.status === 'success' || attr.status === 'cancel'}
            />
          </Grid>
          <Grid item xs={12}>
            <MDSelect
              label='สาขารับเข้า'
              labelDefault={t(`element.please_select`)}
              data={cboBranch}
              value={attr.branch_receive}
              onChange={(e) => setAttr({ ...attr, branch_receive: e.target.value })}
              inputProps={{
                autoComplete: 'off',
                readOnly: readOnly,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='เลขที่สั่งสินค้า'
              onChange={(e) => setAttr({ ...attr, order_no: e.target.value })}
              value={attr.order_no}
              variant='standard'
              inputProps={{
                maxLength: 20,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label={t(`attr.remark`)}
              onChange={(e) => setAttr({ ...attr, remark: e.target.value })}
              value={attr.remark}
              variant='standard'
              multiline
              inputProps={{
                maxLength: 200,
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderSupplier = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h5' mb={3}>
          ผู้จัดจำหน่าย
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={5} lg={4}>
            <MDInput
              label='รหัส'
              value={supplier.code}
              variant='standard'
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
              InputProps={{
                inputProps: {
                  sx: { minWidth: 80 },
                  readOnly: true,
                },
                endAdornment:
                  attr.status === 'edit' ? <SearchSupplier callback={editSupplier} /> : null,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={7} lg={8}>
            <MDInput
              label='ชื่อ'
              value={supplier.name}
              variant='standard'
              multiline
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
              InputProps={{
                inputProps: {
                  readOnly: true,
                },
                endAdornment: (
                  <MDButton
                    variant='text'
                    tabIndex={-1}
                    color='dark'
                    size='small'
                    iconOnly
                    onClick={() => {
                      window.location.replace(`/supplier/${supplier.id}`);
                    }}
                  >
                    <Icon>search</Icon>
                  </MDButton>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <MDInput
              label='เลขที่ผู้เสียภาษี'
              value={supplier.taxid}
              variant='standard'
              multiline
              disabled
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <MDInput
              label='บริษัท'
              value={supplier.company_name}
              variant='standard'
              multiline
              disabled
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <MDInput
              label='สาขา'
              value={supplier.branch}
              variant='standard'
              multiline
              disabled
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='ที่อยู่'
              value={supplier.address}
              variant='standard'
              multiline
              disabled
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <MDInput
              label='เบอร์โทรศัพท์'
              value={supplier.tel}
              variant='standard'
              multiline
              disabled
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <MDInput
              label='E-mail'
              value={supplier.email}
              variant='standard'
              multiline
              disabled
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <MDInput
              label='ภาษีมูลค่าเพิ่ม'
              value={supplier.vat_name}
              variant='standard'
              multiline
              disabled
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <MDInput
              label='ประเภท'
              value={creditDisplay(supplier.credit_type)}
              variant='standard'
              multiline
              disabled
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <MDInput
              label='เครดิต'
              value={supplier.credit_day}
              variant='standard'
              multiline
              disabled
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
              InputProps={{
                endAdornment: <InputAdornment position='end'>วัน</InputAdornment>,
                inputProps: {
                  className: 'text-right',
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <MDInput
              label='วงเงิน'
              value={Func.numberDisplay(supplier.credit_money)}
              variant='standard'
              multiline
              disabled
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
              InputProps={{
                endAdornment: <InputAdornment position='end'>บาท</InputAdornment>,
                inputProps: {
                  className: 'text-right',
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='หมายเหตุ'
              value={supplier.remark === '' ? '-' : supplier.remark}
              variant='standard'
              multiline
              disabled
              fullWidth
              sx={{ backgroundColor: '#ffffff !important' }}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderButton = () => {
    return (
      <MDBox display='flex' justifyContent='end' gap={1}>
        <MDButton variant='gradient' color='warning' onClick={copy}>
          <Icon>content_copy</Icon>&nbsp;{t(`element.copy`)}
        </MDButton>
        <MDButton variant='gradient' color='info' onClick={print}>
          <Icon>print</Icon>&nbsp;ใบสั่งซื้อ {attr.print_no > 0 ? `(${attr.print_no})` : ''}
        </MDButton>
        {attr.is_group === 'Y' ? (
          <MDButton variant='gradient' color='error' onClick={printGroup}>
            <Icon>print</Icon>&nbsp;ใบจัดกลุ่ม {attr.print_no > 0 ? `(${attr.print_no})` : ''}
          </MDButton>
        ) : null}
        <MDButton variant='gradient' color='primary' onClick={detail}>
          <Icon>print</Icon>&nbsp;ใบแนบท้าย {attr.detail_no > 0 ? `(${attr.detail_no})` : ''}
        </MDButton>
        <MDButton variant='gradient' color='dark' onClick={quotation}>
          <Icon>print</Icon>&nbsp;ใบขอราคา {attr.quotation_no > 0 ? `(${attr.quotation_no})` : ''}
        </MDButton>
      </MDBox>
    );
  };

  const renderNavigate = () => {
    return (
      <Card sx={{ p: 2 }}>
        <Grid container>
          <Grid item xs={6}>
            <NavLink to={`/${mod}`}>
              <MDButton variant='contained' color='dark'>
                <Icon>arrow_back</Icon>&nbsp;{t(`element.back`)}
              </MDButton>
            </NavLink>
          </Grid>
          {navigate.first === '' ? null : (
            <Grid item xs={6}>
              <MDBox display='flex' justifyContent='flex-end' gap={1}>
                <NavLink to={`/${mod}/${navigate.first}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.first === id}
                  >
                    <Icon>first_page</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.prev}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.prev === id}
                  >
                    <Icon>navigate_before</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.next}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.next === id}
                  >
                    <Icon>navigate_next</Icon>
                  </MDButton>
                </NavLink>
                <NavLink to={`/${mod}/${navigate.last}`}>
                  <MDButton
                    variant='contained'
                    color='dark'
                    iconOnly
                    disabled={navigate.last === id}
                  >
                    <Icon>last_page</Icon>
                  </MDButton>
                </NavLink>
              </MDBox>
            </Grid>
          )}
        </Grid>
      </Card>
    );
  };

  const renderImage = () => {
    return (
      <Grid container spacing={2}>
        {image.map((item) => (
          <Grid item xs={12} sm={12} md={6} lg={3} key={item.id}>
            <MDBox className='card-img'>
              <CardHeader
                title={`Photo ID : #${item.id}`}
                subheader={Func.dateTimeDisplay(item.created_at)}
              />
              <CardMedia
                sx={{ height: 300 }}
                image={item.image}
                title={item.id}
                onClick={() => openPhoto(item)}
              />
              <CardContent>
                <MDTypography variant='body2'>สร้างโดย : {item.user_name}</MDTypography>
              </CardContent>
            </MDBox>
          </Grid>
        ))}
      </Grid>
    );
  };

  const renderOpen = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {renderNavigate()}
          </Grid>
          <Grid item xs={12}>
            {renderStepper()}
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox sx={{ width: '100%' }}>
                <MDBox>
                  <Tabs
                    value={tab}
                    onChange={(e, v) => setTab(v)}
                    aria-label='tabs-addedit'
                    sx={{ overflowX: 'scroll' }}
                  >
                    <Tab label='ใบสั่งซื้อ' />
                    <Tab
                      label={
                        attr.count_receive > 0 ? `ใบรับเข้า (${attr.count_receive})` : `ใบรับเข้า`
                      }
                    />
                    {image.length > 0 ? <Tab label='ภาพการรับเข้า' /> : null}
                  </Tabs>
                </MDBox>
                <TabPanel value={tab} index={0}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6} xl={6}>
                      <SearchGroup parent={attr} callback={open} />
                    </Grid>
                    <Grid item xs={12} md={6} xl={6}>
                      {renderButton()}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3}>
                      {renderInfo()}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={9}>
                      {renderSupplier()}
                    </Grid>
                    <Grid item xs={12}>
                      <MDBox className='card'>
                        <PurchaseOrderList setLimitApprove={setLimitApprove} ref={listRef} />
                      </MDBox>
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={tab} index={1}>
                  <PurchaseOrderReceive openPhoto={openPhoto} ref={receiveRef} />
                </TabPanel>
                <TabPanel value={tab} index={2}>
                  {renderImage()}
                </TabPanel>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderPhoto = () => {
    return (
      <Dialog
        open={modalPhoto}
        maxWidth='md'
        keepMounted
        aria-describedby='dialog-image'
        fullWidth
        onClose={() => setModalPhoto(false)}
      >
        <DialogTitle>
          {Func.dateTimeDisplay(photo.created_at)}
          <IconButton
            aria-label='close'
            onClick={() => setModalPhoto(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox
            component='img'
            src={photo.image}
            alt=''
            borderRadius='lg'
            shadow='sm'
            width='100%'
            position='relative'
          />
        </DialogContent>
      </Dialog>
    );
  };

  const renderPrint = () => {
    return (
      <Dialog
        open={modalPrint}
        maxWidth='xl'
        keepMounted
        aria-describedby='dialog-print'
        fullScreen
        onClose={() => setModalPrint(false)}
      >
        <DialogTitle>
          #{attr.code}
          <IconButton
            aria-label='close'
            onClick={() => setModalPrint(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          {attr.print === '' ? null : (
            <Iframe
              url={attr.print}
              width='100%'
              height='100%'
              id='print'
              className=''
              display='initial'
              position='relative'
              frameBorder='0'
            />
          )}
        </DialogContent>
      </Dialog>
    );
  };

  const renderQuotation = () => {
    return (
      <Dialog
        open={modalQuotation}
        maxWidth='xl'
        keepMounted
        aria-describedby='dialog-print'
        fullScreen
        onClose={() => setModalQuotation(false)}
      >
        <DialogTitle>
          #{attr.code}
          <IconButton
            aria-label='close'
            onClick={() => setModalQuotation(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          {attr.quotation === '' ? null : (
            <Iframe
              url={attr.quotation}
              width='100%'
              height='100%'
              id='quotation'
              className=''
              display='initial'
              position='relative'
              frameBorder='0'
            />
          )}
        </DialogContent>
        <DialogActions>
          <MDBox display='flex' justifyContent='end' gap={1}>
            <MDButton variant='text' color='dark' onClick={copyLink}>
              <Icon>content_copy</Icon>&nbsp;คัดลอก Link
            </MDButton>
            <MDButton variant='text' color='dark' onClick={openLink}>
              <Icon>open_in_new</Icon>&nbsp;เปิด Link
            </MDButton>
          </MDBox>
        </DialogActions>
      </Dialog>
    );
  };

  const renderPage = () => {
    if (id === undefined) return renderList();
    return renderOpen();
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.purchase`), t(`menu.purchase_order`)]} />
      {renderLoading()}
      {renderPage()}
      {renderPhoto()}
      {renderPrint()}
      {renderQuotation()}
      <Footer />
      {notify}
    </DashboardLayout>
  );
}

export default PurchaseOrder;
